import {SelPanModel} from 'module/selpan/SelPanModel';
import {SisName} from 'util/SisName';
import {PersonAttr} from 'module/selpan/impl/person/model/PersonUtil';
import {parseSisDate, parseSisDateTime} from 'util/SisDateTime';
import moment from 'moment';
import _ from 'lodash';

/**
 * can has different states.
 * selected event is triggered after a delay by collection on last model that got set visible
 * a visible model does not have to be on the current page.
 * The active page is on Collection.filteredCollection.
 */
export const PersonModel = SelPanModel.extend({
	idAttribute: 'persNr',
	urlRoot: '../json/person',
	sisName: SisName.Person,
	initialize: function () {
		this.listenTo(this.model, 'change', () => this.stringRepresentation = PersonAttr.getStringRepresentation(this.attributes));
		this.stringRepresentation = PersonAttr.getStringRepresentation(this.attributes);
	},
	getStringRepresentation: function () {
		return this.stringRepresentation
	},
	getApprovalDateTime: function () {
		return PersonAttr.getApprovalDateTime(this.attributes);
	},
	getBookingEndDateTime: function () {
		return PersonAttr.getBookingEndDateTime(this.attributes);
	},
	getAzeBookingEndDateTime: function () {
		return PersonAttr.getAzeBookingEndDateTime(this.attributes);
	},
	getLimitDateTime: function () {
		return PersonAttr.getLimitDateTime(this.attributes);
	},
	/**
	 *
	 * @param date {Moment|Number|String}
	 * @param [time] {Moment|Number|String}
	 * @return {boolean} true when date is a possible, valid date outside bookingEnd and approval
	 */
	isLimitBefore: function (date, time) {
		time = time || 0;
		date = parseSisDateTime(date, time);
		if (!date.isValid()) return false;
		return this.getLimitDateTime().isBefore(date); //fails if not enriched
	},
	/**
	 * only pze relevant limits
	 *
	 * @param [mom] {moment} if valid moment checks are done against this and only blocking dates are returned. When mom is undefined, all dates are returned.
	 * @returns {boolean | {}} all limits - when mom is defined: false or all blocking limits
	 */
	getBlockingPZELimits: function (mom) {
		let ret;
		let employedFrom = parseSisDate(this.get("angFrom"));
		let employedUntil = parseSisDate(this.get("angTill")).endOf('d');
		let bookingEnd = this.getBookingEndDateTime();
		let approval = this.getApprovalDateTime();
		if (arguments.length > 0 && moment.isMoment(mom) && mom.isValid()) {
			ret = {};
			if (employedFrom.isValid() && mom.isBefore(employedFrom)) {
				_.assign(ret, {employedFrom: employedFrom});
			}
			if (employedUntil.isValid() && mom.isAfter(employedUntil)) {
				_.assign(ret, {employedUntil: employedUntil});
			}
			if (bookingEnd.isValid() && !bookingEnd.isBefore(mom)) {
				_.assign(ret, {bookingEnd: bookingEnd});
			}
			if (approval.isValid() && !approval.isBefore(mom)) {
				_.assign(ret, {approval: approval});
			}
		} else {
			ret = {
				employedFrom: employedFrom,
				employedUntil: employedUntil,
				bookingEnd: bookingEnd,
				approval: approval,
			};
		}
		if (!_.isEmpty(ret)) return ret;
		else return false;
	},
});